import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch topics for a specific community
 */
export const GET_COMMUNITY_TOPICS = gql`
  query GetCommunityTopics($communityId: ID!) {
    community(id: $communityId) {
      id
      topics {
        name
        humanModerationAssignedTtlInSeconds
        maxCasesPerModerator
        humanModerationCasesSlaInSeconds
        isStrikeEnabled
      }
    }
  }
`;
